import React from 'react'
import navimage from '../images/resellerLogo.svg';
import emailicon from '../images/email.svg';
import './sellernavbar.scss'
import { Link, useNavigate } from 'react-router-dom'; 

const SellerNavbar = () => {
    const navigate=useNavigate();

    return (
        <div>
            <div className='sellernavbar'>
                <img src={navimage}
                
                    alt='' onClick={()=>{navigate("/")}}/>
                    
                <a href="mailto:support@onstara.com" target="_blank" rel="noopener noreferrer" className='sellersupportmail'>

                    <div className='sellersupport'>

                        <img src={emailicon}
                            alt=''/>
                        <div>

                            <p style={{fontWeight:600}}>Trouble in Login</p>
                            <p style={{fontWeight:700}}>
                                Support@onstara.com
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default SellerNavbar
